/** Grow an in-memory list one page at a time for infinite scroll. */
export function paginateArray(items, page, perPage = 10) {
  const list = Array.isArray(items) ? items : [];
  const totalPages = Math.max(1, Math.ceil(list.length / perPage) || 1);
  const safePage = Math.min(Math.max(1, page), totalPages);
  return {
    items: list.slice(0, safePage * perPage),
    totalPages,
    currentPage: safePage,
    total: list.length,
  };
}

/** Case-insensitive substring match for list filters. */
export function includesIgnoreCase(haystack, needle) {
  if (!needle) return true;
  return String(haystack ?? '').toLowerCase().includes(String(needle).toLowerCase());
}
